import styled from "styled-components"

export const FormWrapper = styled.div`
.rating_bottom {
    margin-top: 22px;
    padding-top: 12px;
    border-top: 1px solid #e2c1c1;
    display: flex;
    justify-content: space-between;
    button {
        width: 50%;
        height: 35px;
        outline: none;
        border: none;
        &:nth-child(1) {
            background-color: #2f80ed;
            color: #fff;
            border-radius: 4px;
            &:hover {
                background-color: #fff;
                color: #2f80ed;
                border: 1px solid #2f80ed;
            }
        }
        &:nth-child(2) {
            color: #2f80ed;
            border: 1px solid #2f80ed;
            background-color: #fff;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
            &:hover {
                background-color: #2f80ed;
                color: #fff;
            }
        }
    }
}
.rating_form{
    margin-top: 12px;
    padding-top: 12px;
    padding-bottom: 25px;
    h6{
        color: #000000;
        margin: 0;
    }
    textarea{
        width: 100%;
        padding: 8px;
        max-height: 100px;
        min-height: 100px;
        font-size: 1.0rem;
        color: #000000;
        outline: none;
    }
    button{
        position: relative;
        outline: none;
        border: none;
        width: 120px;
        height: 30px;
        background-color: #2f80ed;
        color: #fff;
        border-radius: 4px;
        float: right;
        &:hover{
            background-color: rgb(106, 39, 174);
        }
    }
}

.hidden_form_star_ratting{
    display: none;
}
.show_form_star_ratting{
    display: block;
}
.loading {
    position: absolute;
    top: 5px;
    right: 8px;
    animation: spinner 0.8s linear infinite;
}

`

